import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { CheckCircle2, XCircle } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { fmtDateTime } from "../lib/utils";
import { PageHeader } from "../components/core/Layout";
import { DataTable } from "../components/core/DataTable";
import { TenantSelect } from "../components/shared/TenantSelect";

interface Log { id: string; tenant_id: string; action: string; ok: boolean; detail: string; count: number; created_at: string }

export default function TelematicsSyncLogsPage() {
  const { user } = useAuth();
  const isBO = user?.user_type === "super_admin";
  const [tenantId, setTenantId] = useState("");
  const { data, isLoading } = useQuery<Log[]>({ queryKey: ["telematics-sync-logs", tenantId], queryFn: async () => (await api.get("/telematics/sync-logs", { params: { tenant_id: tenantId || undefined, limit: 100 } })).data, refetchInterval: 30000 });
  return (
    <div data-testid="telematics-sync-logs-page">
      <PageHeader eyebrow="Telematics" title="Sync logs" subtitle="Every call made to Geotab — authentication tests, device pulls, live positions and trip history." actions={isBO && <TenantSelect value={tenantId} onChange={setTenantId} className="w-52" />} />
      <DataTable<Log>
        testId="sync-logs-table" loading={isLoading} rows={data || []} rowKey={(l) => l.id} rowTestId={(l) => `sync-log-${l.id}`}
        columns={[
          { key: "ok", header: "", className: "w-8", render: (l) => l.ok ? <CheckCircle2 className="h-4 w-4 text-emerald-600" /> : <XCircle className="h-4 w-4 text-rose-600" /> },
          { key: "when", header: "When", render: (l) => <span className="text-xs">{fmtDateTime(l.created_at)}</span> },
          { key: "action", header: "Action", render: (l) => <span className="rounded bg-slate-100 px-2 py-0.5 font-mono text-[11px] font-semibold uppercase text-slate-700">{l.action}</span> },
          { key: "detail", header: "Detail", render: (l) => <span className={`text-xs ${l.ok ? "text-slate-700" : "text-rose-700"}`}>{l.detail}</span> },
          { key: "count", header: "Records", render: (l) => <span className="text-xs">{l.count}</span> },
        ]}
        empty="No Geotab calls yet."
      />
    </div>
  );
}
